module.exports = __webpack_public_path__ + "static/media/avatarOthers.1bd38334.png";